<template>
    <div>
      <EuiGridRow v-if="getterIsLoading">
        <EuiLoader :is-loading="getterIsLoading"/>
        <EuiHeading :level="2">En cours de chargement</EuiHeading>
      </EuiGridRow>
      <EuiGridRow v-else-if="getterResult.length ===0">
        <EuiHeading :level="2">Aucun coffre ne correspond</EuiHeading>
      </EuiGridRow>
      <div v-else>
        <EuiGridRow>
          <EuiHeading :level="3" bold class="mt-2">
            Nombre de coffre trouvé: {{ getterResult.length }}
          </EuiHeading>
        </EuiGridRow>
        <EuiGridRow v-for="boxe in getterResult" :key="boxe.index" class="mt-5">
          <chest-card :detailBoxe="boxe"/>
        </EuiGridRow>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import chestCard from '@/components/chestCard.vue';

/*
This component displays the result
 */
export default {
  name: 'components.resultCard',
  components: {
    chestCard,
  },
  computed: {
    ...mapGetters({
      getterResult: 'boxes/result',
      getterIsLoading: 'application/isLoading',
    }),
  },
};
</script>
